import React from "react";
import { Send, FileCode2, SearchCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import PrintMenu from "@/components/PrintMenu";

// Acciones de fila idénticas en todos los módulos: Imprimir · XML · Enviar DGII · Verificar · extras.
export default function DocRowActions({
  printUrl, filename, onXml, onSend, sendTitle = "Enviar a DGII", onVerify, testids = {}, children,
}) {
  return (
    <div className="inline-flex items-center justify-end gap-0.5">
      <PrintMenu url={printUrl} filename={filename} label="" iconOnly variant="ghost" size="icon" testid={testids.print} />
      {onXml && (
        <Button size="icon" variant="ghost" onClick={onXml} title="Descargar XML e-CF" data-testid={testids.xml}>
          <FileCode2 className="w-4 h-4 text-primary" />
        </Button>
      )}
      {onSend && (
        <Button size="icon" variant="ghost" onClick={onSend} title={sendTitle} data-testid={testids.send}>
          <Send className="w-4 h-4 text-primary" />
        </Button>
      )}
      {onVerify && (
        <Button size="icon" variant="ghost" onClick={onVerify} title="Verificar estado en DGII (trackId)" data-testid={testids.verify}>
          <SearchCheck className="w-4 h-4 text-muted-foreground" />
        </Button>
      )}
      {children}
    </div>
  );
}
